module.exports = __webpack_public_path__ + "img/vvv-logo-transparent.bae62b54.png";